import { Chip } from '@mui/material'
import { useIntl } from 'react-intl'
import messages from './messages'
import { ImpersonationGrantStatus } from './types'

// E11 R1 (WI 611) — the grant status badge. Active=green (success), Used=blue (info), Expired=grey (default),
// Revoked=red (error). Mirrors the app's existing MUI Chip badge style (see VerifiedDomains/StatusChip).
const STATUS_COLOR: Record<ImpersonationGrantStatus, 'success' | 'info' | 'default' | 'error'> = {
  Active: 'success',
  Used: 'info',
  Expired: 'default',
  Revoked: 'error',
}

const ImpersonationStatusBadge = ({ status }: { status: ImpersonationGrantStatus }) => {
  const { formatMessage } = useIntl()

  const label = () => {
    switch (status) {
      case 'Active':
        return formatMessage(messages.statusActive)
      case 'Used':
        return formatMessage(messages.statusUsed)
      case 'Expired':
        return formatMessage(messages.statusExpired)
      case 'Revoked':
        return formatMessage(messages.statusRevoked)
      default:
        return status
    }
  }

  return <Chip size='small' color={STATUS_COLOR[status] ?? 'default'} label={label()} />
}

export default ImpersonationStatusBadge
